module.exports = __webpack_public_path__ + "static/avatar-default-257bd08f5f373d3825b1cc5e37c0005b.jpg";